import { jsx as n, jsxs as u } from "react/jsx-runtime";
import { c as x } from "./clsx-OuTLNxxd.js";
import { I as L } from "./icon-B72I4fRl.js";
import "./components/elements/icon/iconsList.js";
const g = "_link_n9jfs_29", s = {
  link: g,
  "is-small": "_is-small_n9jfs_37",
  "is-primary": "_is-primary_n9jfs_41",
  "is-secondary": "_is-secondary_n9jfs_47",
  "is-inverted": "_is-inverted_n9jfs_53",
  "is-inherited": "_is-inherited_n9jfs_59",
  "is-underlined": "_is-underlined_n9jfs_65",
  "is-disabled": "_is-disabled_n9jfs_78",
  "link-external": "_link-external_n9jfs_87",
  "dialog-overlay-show": "_dialog-overlay-show_n9jfs_1",
  "dialog-content-show": "_dialog-content-show_n9jfs_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_n9jfs_1"
}, v = {
  primary: "is-primary",
  secondary: "is-secondary",
  inverted: "is-inverted",
  inherit: "is-inherited"
};
function O({
  color: f = "primary",
  children: i,
  href: l,
  target: t,
  disabled: e,
  Component: d,
  isSmall: p,
  className: j,
  noUnderline: y = !1,
  external: k,
  ariaLabel: m,
  onClick: r,
  ...a
}) {
  const o = x(
    s.link,
    s[v[f]],
    p && s["is-small"],
    e && s["is-disabled"],
    !y && s["is-underlined"],
    j
  ), _ = /* @__PURE__ */ n("span", { className: o, ...a, children: i });
  if (d)
    return e ? _ : /* @__PURE__ */ n(d, { onClick: r, className: o, href: l, target: t, "aria-label": m, ...a, children: i });
  if (!l)
    return e ? _ : /* @__PURE__ */ n("button", { onClick: r, className: o, ...a, children: i });
  const c = /* @__PURE__ */ n(
    "a",
    {
      onClick: r,
      href: l,
      target: t,
      className: o,
      "aria-label": m,
      ...a,
      children: i
    }
  );
  return e ? _ : k ? /* @__PURE__ */ u("span", { className: s["link-external"], children: [
    c,
    /* @__PURE__ */ n(L, { name: "new-tab", size: "large" })
  ] }) : c;
}
export {
  O as L,
  s
};
